<div
  class="timebox-trigger w-full"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="timePickerMenu"
  [matMenuTriggerRestoreFocus]="false"
  (menuOpened)="onMenuOpen()"
  (menuClosed)="onMenuClose()"
>
  <mat-form-field
    #timePickerInput
    appearance="outline"
    floatLabel="always"
    class="sia-inputs-full sia-input w-full"
    [class]="inputClass()"
    [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
    (click)="handleFormFieldClick($event)"
  >
    <mat-label>{{ label() | siaTranslate }}</mat-label>

    <input
      #inputElement
      matInput
      type="text"
      [disabled]="isDisabled()"
      [ngModel]="stringValue()"
      (ngModelChange)="onInput($event)"
      (keydown)="onKeyDown($event)"
      (pointerdown)="onInputPointerDown($event)"
      (focus)="onInputFocus()"
      (click)="onInputFocus()"
      (blur)="onBlur($event)"
    />

    <button
      type="button"
      mat-icon-button
      matSuffix
      (mousedown)="$event.preventDefault()"
      (click)="onIconClick($event)"
      [disabled]="isDisabled()"
      class="w-9"
    >
      <mat-icon>schedule</mat-icon>
    </button>

    @if (showBottomMargin()) {
      <mat-hint
        sia-error-hint
        [statusMessage]="statusMessage()"
        [statusMessages]="statusMessages()"
      ></mat-hint>
    }
  </mat-form-field>
</div>

<mat-menu
  #timePickerMenu="matMenu"
  yPosition="below"
  xPosition="before"
  [overlapTrigger]="false"
>
  <div
    #scrollableList
    class="relative h-60 overflow-y-auto"
    (mousedown)="$event.preventDefault()"
    (click)="$event.stopPropagation()"
  >
    @for (item of hoursList(); track item.hours + ':' + item.minutes) {
      <button
        mat-menu-item
        (click)="onMenuItemClick(item.hours, item.minutes)"
        [class.bg-primary-container]="stringValue() === item.description"
        class="hover:bg-primary-container transition-colors"
      >
        <div class="flex w-full items-center justify-between gap-2">
          <span
            class="text-base"
            [class.font-semibold]="stringValue() === item.description"
            [class.text-primary]="stringValue() === item.description"
          >
            {{ item.label }}
          </span>
          @if (stringValue() === item.description) {
            <mat-icon class="text-primary !mr-0 scale-75">check</mat-icon>
          }
        </div>
      </button>
    }
  </div>
</mat-menu>
